import React from 'react';
import { useNavigate } from 'react-router-dom';
import ENV_CONFIG from '../config';

function Logout({ user, setUser }) {
  const navigate = useNavigate();

  // Get environment from localStorage, default to 'dev'
  const environment = localStorage.getItem('environment') || 'dev';
  const { baseUrl } = ENV_CONFIG[environment];

  const handleLogout = async () => {
    // Get the most recent user data from localStorage
    const storedUser = localStorage.getItem('user');
    const currentUser = storedUser ? JSON.parse(storedUser) : user;

    if (!currentUser || !currentUser.IdToken || !currentUser.AccessToken) {
      console.error('No IdToken or AccessToken available for logout');
      return;
    }

    const url = `${baseUrl}/api/user-management/users/logout`;
    const payload = {
      accessToken: currentUser.AccessToken,
      fcmToken: 'logout' // Replace with actual FCM token if available
    };

    const headers = {
      'Authorization': `${currentUser.IdToken}`,
      'Content-Type': 'application/json'
    };

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        setUser(null);
        localStorage.removeItem('user');
        console.log('Logout successful');
        navigate('/'); // Redirect to home page
      } else {
        console.error('Logout failed');
      }
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <button onClick={handleLogout} className="btn btn-outline-danger">
      Logout
    </button>
  );
}

export default Logout;